export const CATEGORY_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
};

export const STATUS_OPTIONS = [
  { value: CATEGORY_STATUS.ACTIVE, label: "Active" },
  { value: CATEGORY_STATUS.INACTIVE, label: "Inactive" },
];

export const HOME_VIEW_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const SEO_LIMITS = {
  META_TITLE: 60,
  META_DESCRIPTION: 155,
  PAGE_TITLE: 70,
};

export const POSITION_MIN = 1;
export const POSITION_MAX = 50;
